import { render, staticRenderFns } from "./SearchStorageProducts.vue?vue&type=template&id=483b3868&scoped=true&"
import script from "./SearchStorageProducts.vue?vue&type=script&lang=js&"
export * from "./SearchStorageProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483b3868",
  null
  
)

export default component.exports